import {
  Component,
  Inject,
  OnInit,
  ElementRef,
  ViewChild,
  Renderer2,
  HostListener,
  OnDestroy,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { GenerateDocumentPopupComponent } from '../../template/generate-document-popup/generate-document-popup.component';
import { GSUITE_CONST } from 'src/app/_constant/invoiceOption-popup.const';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ToastrService } from 'ngx-toastr';
import { MainAPiServiceService } from '@_services/main-api-service.service';
import { BehaviorService } from '@_services/Behavior.service';
import { ImageSizemeasurementService } from '@_services/image-sizemeasurement.service';
import { FuseConfirmDialogComponent } from '@/app/Shared/confirm-dialog/confirm-dialog.component';
import { DIALOG_WIDTH } from '@/app/_constant/dialog-width.constants';

@Component({
  selector: 'app-invoice-templates-popup',
  templateUrl: './invoice-templates-popup.component.html',
  styleUrls: ['./invoice-templates-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class InvoiceTemplatesPopupComponent implements OnInit, OnDestroy {
  @ViewChild('imageContainer') imageContainer: ElementRef;
  @ViewChild('imageFooterContainer') imageFooterContainer: ElementRef;
  @ViewChild('imageValueData') imageValueData: ElementRef;
  private isDragging: boolean = false;
  private isDraggingfooter: boolean = false;
  private initialX: number = 0;
  private initialY: number = 0;
  offsetX: number = 0;
  offsetY: number = 0;
  private initialXfooter: number = 0;
  private initialYfooter: number = 0;
  left: number;
  right: number;
  height: number;
  width: number;
  step = 0;
  fileToUpload: any = [];
  fileToUpload_footer = [];
  finalfileToUpload_footer: any;
  GLOBLE_DROPDOWN_CONST = GSUITE_CONST;
  isspiner: boolean = false;
  InvoiceTemplatePopup: FormGroup;
  dataAPi: any;
  getDropDownValue: any;
  filterdata: any;
  srcResult: any;
  finalfileToUpload: any;
  isLoadingResults: boolean = true;
  hadderSettingImage: boolean = false;
  FooterSettingImage: boolean = false;
  GTemplateId: string;
  filefolderUrlDes: any;
  templateId: any;
  zoomFactor = 1;
  originalWidth: number;
  originalHeight: number;
  UpdatedWidthValue: number = 195;
  previousHeight: any;
  zoomFooter = 1;
  initialYValueOfFooterImage;
  offsetXFooter: number = 0;
  offsetYFooter: number = 0;
  defaultXpos: number;
  defaultYpos: number;
  defaultWidth: number;
  defaultHeight: number;
  defaultXposfooter: number;
  defaultYposfooter: number;
  defaultWidthfooter: number;
  defaultHeightfooter: number;
  isShowAccountInfo: boolean = false;
  constructor(
    private _mainAPiServiceService: MainAPiServiceService,
    public dialogRef: MatDialogRef<InvoiceTemplatesPopupComponent>,
    public _matDialog: MatDialog,
    private toastr: ToastrService,
    private _formBuilder: FormBuilder,
    public behaviorService: BehaviorService,
    private _snackBar: MatSnackBar,
    private renderer: Renderer2,
    public confirmDialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public _data: any,
    private imageservice: ImageSizemeasurementService,
    private elementRef: ElementRef,
  ) {}

  ngOnInit() {
    this.InvoiceTemplatePopup = this._formBuilder.group({
      // TEMPLATEID: [''],
      TemplateId: [''],
      // Font Settings
      // TEMPLATENAME : [''],
      TEMPLATEFONT: [''],
      TEMPLATEFONTSIZE: [''],
      TEMPLATEFONTCOLOUR: [''],
      // Header Settings
      HEADERSTYLE: [''],
      HEADERIMAGEFILE: [''],
      HEADERIMAGEDATA: [''],
      HEADERIMAGEXPOS: [''],
      HEADERIMAGEYPOS: [''],
      HEADERIMAGEWIDTH: [''],
      HEADERIMAGEHEIGHT: [''],
      HEADERHEIGHT: [''],
      // Footer Settings
      FOOTERSTYLE: [''],
      FOOTERIMAGEFILE: [''],
      FOOTERIMAGEDATA: [''],
      FOOTERIMAGEXPOS: [''],
      FOOTERIMAGEYPOS: [''],
      FOOTERIMAGEWIDTH: [''],
      FOOTERIMAGEHEIGHT: [''],
      FOOTERHEIGHT: [''],
      // General Layout
      TAXINVOICETITLE: [''],
      ABNLOCATION: [''],
      PADZEROSINVOICENUMBER: [''],
      RELINEJUSTIFICATION: [''],
      SHOWMATTERREFERENCE: [''],
      INDENTADDRESSEEDETAILS: [''],
      SHOWADDRESSEEPOSITION: [''],
      MATTERNOLOCATION: [''],
      MATTERNOFORMAT: [''],
      INVOICENUMBERPOSITION: [''],
      SHOWCOURTDETAILS: [''],
      // Summary Information
      SHOWFIRSTPAGESUMMARY: [''],
      SHOWDATERANGEONFEES: [''],
      FEESDESCRIPTION: [''],
      DISBURSEMENTDESCRIPTION: [''],
      TRUSTAUTHORITYSTATEMENT: [''],
      SHOWSOLICITORSUMMARY: [''],
      SOLSUMMARYSTYLE: [''],
      SHOWDELIVERABLESUMMARY: [''],
      // Financial Details
      SHOWWRITTENOFFAMOUNT: [''],
      SHOWRECEIVEDAMOUNT: [''],
      SHOWBILLINGRECIPIENT: [''],
      SHOWTRUSTBALANCES: [''],
      SHOWFOREIGNCURRENCY: [''],
      GROUPSECRETARIALWORK: [''],
      OUTSTANDINGTABLE: [''],
      OUTSTANDINGSHOWWRITTENOFF: [''],
      OUTSTANDINGSHOWINTEREST: [''],
      // Statements
      SHOWWITHCOMPLIMENTS: [''],
      SHOWSTATEMENTS: [''],
      SHOWSTATEMENT2: [''],
      SHOWSTATEMENT3: [''],
      SHOWSTATEMENT4: [''],
      BANKDETAILSDONTCHANGE: [''],
      WITHCOMPLIMENTSTEXT: [''],
      SHOWPERSONRESPONSIBLEEMAIL: [''],
      // Remittance
      SHOWREMITTANCE: [''],
      SHOWBANKDETAILSDONTCHANGE: [''],
      SHOWCREDITCARDOPTION: [''],
      SHOWDIRECTDEBITOPTION: [''],
      DIRECTDEBITACCOUNT: [''],
      SHOWMAILOPTION: [''],
      DIRECTDEBITBSB: [''],
      DIRECTDEBITACCOUNTNO: [''],
      DIRECTDEBITACCOUNTNAME: [''],
      // Work Items
      HIDETIMEENTRIES: [''],
      USEDELIVERABLES: [''],
      SHOWTAXESAS: [''],
      SHOWINDIVIDUALCOSTS: [''],
      DISPLAYQUANTITYTYPE: [''],
      SHOWWORKITEMQUANTITY: [''],
      SHOWFEEEARNER: [''],
      SHOWDATESONCE: [''],
      SHOWDISBURSEMENTSONNEWPAGE: [''],
      SHOWDISBURSEMENTPAYEE: [''],
      DATEFORMAT: [''],
      ADDEANDOELINE: [''],
      SUMMARYLABELPOSITION: [''],
      BUTSAYTEXT: [''],
      // Signature Details
      PERSONRESPONSIBLE: [''],
      PERSONRESPONSIBLETITLE: [''],
      SHOWADDRESSEEEMAIL: [''],
      HIDEPRACTICENAME: [''],
      STATEMENTAFTERSIGNATURE: [''],
      DONTSHOWOTHEROUTSTANDING: [''],
    });
    this.defaultWindowLoad();
  }

  /**
   * save the particular invoice
   * @param type parameter of type like add,edit,delete
   * @returns
   */
  setOptions(type?: string) {
    if (type != 'default') {
      let id = `${'Internal:' + this.dataAPi.Data.TemplateId}`;
      this.dataAPi.Data.TemplateId = id;
      this.dataAPi.Data.HEADERIMAGEXPOS =
        this.InvoiceTemplatePopup.controls['HEADERIMAGEXPOS'].value;
      this.dataAPi.Data.HEADERIMAGEYPOS =
        this.InvoiceTemplatePopup.controls['HEADERIMAGEYPOS'].value;
      this.dataAPi.Data.HEADERIMAGEWIDTH =
        this.InvoiceTemplatePopup.controls['HEADERIMAGEWIDTH'].value;
      this.dataAPi.Data.HEADERIMAGEHEIGHT =
        this.InvoiceTemplatePopup.controls['HEADERIMAGEHEIGHT'].value;

      this.dataAPi.Data.FOOTERIMAGEXPOS =
        this.InvoiceTemplatePopup.controls['FOOTERIMAGEXPOS'].value;
      this.dataAPi.Data.FOOTERIMAGEYPOS =
        this.InvoiceTemplatePopup.controls['FOOTERIMAGEYPOS'].value;
      this.dataAPi.Data.FOOTERIMAGEWIDTH =
        this.InvoiceTemplatePopup.controls['FOOTERIMAGEWIDTH'].value;
      this.dataAPi.Data.FOOTERIMAGEHEIGHT =
        this.InvoiceTemplatePopup.controls['FOOTERIMAGEHEIGHT'].value;
    }

    if (this.isShowAccountInfo == false) {
      this.dataAPi.Data.DIRECTDEBITACCOUNTNAME = '';
      this.dataAPi.Data.DIRECTDEBITACCOUNTNO = '';
      this.dataAPi.Data.DIRECTDEBITBSB = '';
    }
    this.isLoadingResults = true;
    return new Promise((res, rej) => {
      // this.sub = this._mainAPiServiceService.getSetData(this.dataAPi, 'SetSystem').subscribe(response => {
      this._mainAPiServiceService.getSetData(this.dataAPi, 'system').subscribe(
        (response) => {
          if (response.DATA && response.CODE == 200) {
            this.filterdata =
              response.DATA && response.DATA.DEFAULTVALUES ? response.DATA.DEFAULTVALUES : [];
            this.isLoadingResults = false;
            if (this.filterdata && type !== 'Preview') {
              this.setValue();
            }

            if (type == 'create' || type == 'edit' || type == 'duplicate') {
              this.behaviorService.refreshTemplateOptionsList.next(type);
            }
            if (type == 'Preview') {
              setTimeout(() => {
                this.getPreviewData();
              }, 1500);
            }
          }
          res(response);
        },
        (error) => {
          this.isLoadingResults = false;
          this.toastr.error(error);
        },
      );
    });
  }

  /**
   * preview particular invoice
   */
  getPreviewData() {
    this.templateId = this.dataAPi.Data.TemplateId;
    //this.templateId='INTINV:Internal:CostsHidden'
    const ReportData = {
      Context: 'Invoice',
      ContextGuid: '_PREVIEW_',
      SCHEDULEREQUEST: true,
      Type: 'Template',
      Template: `${'<' + 'INTINV:' + this.templateId + '>'}`,
      //Template:this.templateId,
      CHECKFORPROMPTS: false,
      MainFlag: 'True',
      knownby: 'Template',
    };

    let dialogRef: any;

    dialogRef = this._matDialog.open(GenerateDocumentPopupComponent, {
      width: DIALOG_WIDTH.W850,
      disableClose: true,
      data: ReportData,
    });

    // this._mainAPiServiceService.SetDocuments(ReportData, 'TemplateGenerate').subscribe(async response => {
    //   if (response.CODE == '200' && response.STATUS == "success") {
    //       this.toastr.success('TemplateGenerate successfully');
    //       this.filefolderUrlDes = response.DATA.DOCUMENTS[0]
    //     this.isLoadingResults = false;
    //   } else if (response.CODE == 420) {
    //     this.isLoadingResults = false;
    //     this.dialogRef.close();
    //   } else if (response.CODE == 428) {
    //     this.isLoadingResults = false;
    //   } else if (response.CODE == 432) {
    //     this.isLoadingResults = false;
    //   } else if (response.CODE == 431) {

    //     this.isLoadingResults = false;
    //   } else if (response.STATUS == 'error' || response.CODE == '422') {
    //     this.isLoadingResults = false;
    //     this.dialogRef.close(false);
    //   } else if (response.MESSAGE == 'Not logged in') {
    //     this.isLoadingResults = false;
    //     this.dialogRef.close(false);
    //   }
    //   // await this.socketService.closeSocket(this.currentUser.SessionToken, "TemplateGenerateStatus");
    // }, error => {
    //   this.isLoadingResults = false;
    //   this.toastr.error(error);
    //   this.dialogRef.close();
    //   // this.socketService.closeSocket(this.currentUser.SessionToken, "TemplateGenerateStatus");
    // });
  }

  /**
   *
   * @returns fnction is called when action is edit and set the values to formData
   */
  loadOptionWindow() {
    this.finalfileToUpload = '';
    this.finalfileToUpload_footer = '';
    let data = {
      Action: 'GetData',
      Filters: {
        GroupName: 'InvoiceTemplates',
        TemplateID: this._data.InvoiceValueGetData.VALUE,
      },
    };
    return new Promise((res, rej) => {
      this._mainAPiServiceService.getSetData(data, 'system').subscribe((response) => {
        this.filterdata = response.DATA.RECORDS;
        // this.filterdata = this.getDropDownValue.INVOICETEMPLATESETTINGS.filter(e => e.TEMPLATEID == this._data.InvoiceValueGetData.VALUE)[0];
        this.isLoadingResults = false;
        if (
          this.filterdata !== null &&
          this.filterdata != 'undefined' &&
          this.filterdata != undefined &&
          (this._data.Type == 'edit' || this._data.Type == 'duplicate')
        ) {
          if (this.filterdata.HEADERSTYLE == 'User image') {
            this.hadderSettingImage = true;
            this.finalfileToUpload = [this.filterdata.HEADERIMAGEDATA];
            this.defaultXpos = this.imageservice.setDefaultXPositionHeaderImage(
              this.filterdata.HEADERIMAGEXPOS,
            );
            this.defaultYpos = this.imageservice.setDefaultYPositionHeaderImage(
              this.filterdata.HEADERIMAGEYPOS,
            );
            this.defaultWidth = this.imageservice.setDefaultWidthToHeaderImage(
              this.filterdata.HEADERIMAGEWIDTH,
            );
            this.defaultHeight = this.imageservice.setDefaultHeightToHeaderImage(
              this.filterdata.HEADERIMAGEHEIGHT,
            );
            setTimeout(() => {
              const containerElement: HTMLElement =
                this.elementRef.nativeElement.querySelector('.mb-1000');
              if (containerElement) {
                const rect = containerElement.getBoundingClientRect();
                this.width = rect.width;
                this.left = rect.left;
                this.right = rect.top;
                this.height = rect.height;
                if (this.filterdata && this.filterdata.HEADERIMAGEXPOS >= 0) {
                  this.zoomFactor = this.defaultWidth / this.width;
                }
                containerElement.style.left = this.defaultXpos + 'px';
                containerElement.style.top = this.defaultYpos + 'px';
              }
            }, 500);
          }
          if (this.filterdata.FOOTERSTYLE == 'User image') {
            this.FooterSettingImage = true;
            this.finalfileToUpload_footer = [this.filterdata.FOOTERIMAGEDATA];

            this.defaultXposfooter = this.imageservice.setDefaultXPositionFooterImage(
              this.filterdata.FOOTERIMAGEXPOS,
            );
            this.defaultYposfooter = this.imageservice.setDefaultYPositionFooterImage(
              this.filterdata.FOOTERIMAGEYPOS - 8000,
            );
            this.defaultWidthfooter = this.imageservice.setDefaultWidthToFooterImage(
              this.filterdata.FOOTERIMAGEWIDTH,
            );
            this.defaultHeightfooter = this.imageservice.setDefaultHeightToFooterImage(
              this.filterdata.FOOTERIMAGEHEIGHT,
            );

            setTimeout(() => {
              const containerElement: HTMLElement =
                this.elementRef.nativeElement.querySelector('.mb-1000-footer');
              if (containerElement) {
                const rect = containerElement.getBoundingClientRect();
                this.width = rect.width;
                this.left = rect.left;
                this.right = rect.top;
                this.height = rect.height;
                if (this.filterdata && this.filterdata.FOOTERIMAGEXPOS >= 0) {
                  this.zoomFooter = this.defaultWidthfooter / this.width;
                }
                containerElement.style.left = this.defaultXposfooter + 'px';
                containerElement.style.top = this.defaultYposfooter + 'px';
              }
            }, 500);
          }
          this.setValue();
        }
        res(response);
      });
    });
  }

  ngOnDestroy(): void {}

  /**
   * THis function is used to load the default window
   */
  defaultWindowLoad() {
    if (this._data.Type == 'new') {
      this.finalfileToUpload = '';
      this.finalfileToUpload_footer = '';
      this.fileToUpload = [];
      this.fileToUpload_footer = [];
      this.dataAPi = { FormAction: 'default invoice template', Data: {} };
      this.setOptions('default');
    } else if (this._data.Type == 'edit') {
      // this.dataAPi = { FormAction: "update invoice template", Data: { "TemplateId": this._data.InvoiceValueGetData.VALUE } }
      this.dataAPi = { TemplateId: this._data.InvoiceValueGetData.VALUE };
      this.loadOptionWindow();
    } else if (this._data.Type === 'duplicate') {
      this.dataAPi = { TemplateId: '' };
      this.loadOptionWindow();
    }
  }

  /**
   * function is called to save the particular invoice data
   * @param IsAction parameter of particular action if it new, edit or delete
   * @returns
   */
  SaveData(IsAction) {
    this.InvoiceTemplatePopup.controls['HEADERIMAGEDATA'].setValue(
      this.finalfileToUpload && this.finalfileToUpload[0] ? this.finalfileToUpload[0] : '',
    );
    this.InvoiceTemplatePopup.controls['FOOTERIMAGEDATA'].setValue(
      this.finalfileToUpload_footer && this.finalfileToUpload_footer[0]
        ? this.finalfileToUpload_footer[0]
        : '',
    );
    let TemplateName = this.InvoiceTemplatePopup.controls['TemplateId'].value;
    TemplateName = TemplateName?.replaceAll(' ', '');

    if (!TemplateName && TemplateName == '') {
      this.toastr.error("Template name it's required");
      return;
    }

    if (this.InvoiceTemplatePopup.valid) {
      //this.InvoiceTemplatePopup.controls['TemplateId'].setValue('Internal:' + TemplateName);
      this.InvoiceTemplatePopup.controls['TemplateId'].setValue(TemplateName);

      if (IsAction == 'new') {
        this.dataAPi = {
          FormAction: 'insert invoice template',
          Data: this.InvoiceTemplatePopup.value,
        };
        this.setOptions('create');
        this.dialogRef.close();
      } else if (IsAction == 'edit') {
        // this.dataAPi = { FormAction: "update invoice template", Data: this.InvoiceTemplatePopup.value }
        this.dataAPi = {
          Action: 'update invoice template',
          Data: this.InvoiceTemplatePopup.value,
        };
        this.setOptions('edit');
        this.dialogRef.close();
      } else if (IsAction == 'Preview') {
        this.dataAPi = {
          FormAction: 'update invoice template',
          Data: this.InvoiceTemplatePopup.value,
        };
        this.setOptions('Preview');
        // this.dialogRef.close()
      } else if (IsAction == 'duplicate') {
        this.templateId = { TemplateId: this.templateId };
        this.dataAPi = {
          Action: 'insert invoice template',
          Data: this.InvoiceTemplatePopup.value,
        };
        this.setOptions('create');
        this.dialogRef.close();
      }
    } else {
      this.toastr.error('form field missing!');
    }
  }

  /**
   * function is called to set the form value
   */
  setValue() {
    for (let d in this.InvoiceTemplatePopup.controls) {
      this.controlData = d;
    }
  }

  set controlData(i) {
    if (i == 'TemplateId') {
      let tamplateName = this._data.Type !== 'duplicate' ? this.filterdata['TEMPLATEID'] : '';
      if (tamplateName && tamplateName != '') {
        tamplateName = tamplateName.split('Internal:')[1]?.toString();
      }
      this.InvoiceTemplatePopup.controls[i].setValue(tamplateName);
    } else if (i == 'DIRECTDEBITACCOUNT') {
      if (this.filterdata[i] == 'Manual Entry') {
        this.isShowAccountInfo = true;
      } else {
        this.isShowAccountInfo = false;
      }
      this.InvoiceTemplatePopup.controls[i].setValue(this.filterdata[i]);
    } else {
      this.InvoiceTemplatePopup.controls[i].setValue(this.filterdata[i]);
    }
  }

  get LoadFormControl() {
    return this.InvoiceTemplatePopup.value;
  }

  /**
   * This function is used to  select the file
   */
  onFileSelected() {
    const inputNode: any = document.querySelector('#file');
    if (typeof FileReader !== 'undefined') {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.srcResult = e.target.result;
      };
      reader.readAsArrayBuffer(inputNode.files[0]);
    }
  }

  // selectDocUpload(fileInput: any) {
  //   let file64bit : any = [];
  //   let files = fileInput;

  //   var reader = new FileReader();
  //   reader.readAsDataURL(files[0] ? files[0] : files);
  //   reader.onload = ()=>{
  //      file64bit = reader.result;
  //      this.InvoiceTemplatePopup.controls['HEADERIMAGEFILE '].patchValue(files[0].name);
  //      this.InvoiceTemplatePopup.controls['HEADERIMAGEDATA'].patchValue(file64bit);
  //   };
  //   reader.onerror = function (error) {
  //   };

  //   // this.finalfileToUpload = file64bit[0];
  //   // this.InvoiceTemplatePopup.controls['HEADERIMAGEFILE'].patchValue(files[0].name);
  // }
  selectDocUpload(fileInput: any) {
    let file64bit = [];
    let filenames = [];
    let files = fileInput;
    var reader = new FileReader();
    reader.readAsDataURL(files[0] ? files[0] : files);
    reader.onload = function () {
      file64bit.push(reader.result);
    };
    reader.onerror = function (error) {};
    this.finalfileToUpload = file64bit;
  }
  imageSelect(event) {
    if (event.value == 'User image') {
      this.hadderSettingImage = true;
    } else {
      this.hadderSettingImage = false;
    }
  }
  footerimageSelect(event) {
    if (event.value == 'User image') {
      this.FooterSettingImage = true;
    } else {
      this.FooterSettingImage = false;
    }
  }
  onFileChange(pFileList: File[]) {
    if (pFileList['size'] <= 100000 || (pFileList[0] && pFileList[0].size) <= 100000) {
      this.selectDocUpload(pFileList);
      this.fileToUpload = pFileList['name'] ? pFileList['name'] : pFileList[0]['name'];
      this.InvoiceTemplatePopup.controls['HEADERIMAGEFILE'].setValue(this.fileToUpload);
      setTimeout(() => {
        this.getImagePosition();
      }, 2000);
      this._snackBar.open('Successfully upload!', 'Close', {
        duration: 2000,
      });
    } else {
      this.toastr.error('Please Select up to 100kb Size Image');
    }
  }

  remove() {
    this.confirmDialogRef = this._matDialog.open(FuseConfirmDialogComponent, {
      disableClose: true,
      width: DIALOG_WIDTH.FULL,
    });
    this.confirmDialogRef.componentInstance.confirmMessage =
      'Are you sure you want to remove this Item?';
    this.confirmDialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.fileToUpload = [];
        this.finalfileToUpload = '';
        this.InvoiceTemplatePopup.controls['HEADERIMAGEFILE'].setValue(this.finalfileToUpload);
      }
    });
  }
  onFileChange_footer(pFileList_footer: File[]) {
    if (
      pFileList_footer['size'] <= 100000 ||
      (pFileList_footer[0] && pFileList_footer[0].size) <= 100000
    ) {
      this.selectDocUpload_footer(pFileList_footer);
      this.fileToUpload_footer = pFileList_footer['name']
        ? pFileList_footer['name']
        : pFileList_footer[0]['name'];

      this.InvoiceTemplatePopup.controls['FOOTERIMAGEFILE'].setValue(this.fileToUpload_footer);
      this._snackBar.open('Successfully upload!', 'Close', {
        duration: 2000,
      });
    } else {
      this.toastr.error('Please Select up to 100kb Size Image');
    }
  }
  remove_footer() {
    this.confirmDialogRef = this._matDialog.open(FuseConfirmDialogComponent, {
      disableClose: true,
      width: DIALOG_WIDTH.FULL,
    });
    this.confirmDialogRef.componentInstance.confirmMessage =
      'Are you sure you want to remove this Item?';
    this.confirmDialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.fileToUpload_footer = [];
        this.finalfileToUpload_footer = '';
        this.InvoiceTemplatePopup.controls['FOOTERIMAGEFILE'].setValue(
          this.finalfileToUpload_footer,
        );
      }
    });
  }

  /**
   * This function is used to selectDocumant Upload footer
   */
  selectDocUpload_footer(fileInput: any) {
    let file64bit_footer = [];
    let filenames = [];
    let files_footer = fileInput;
    var reader = new FileReader();
    reader.readAsDataURL(files_footer[0] ? files_footer[0] : files_footer);
    reader.onload = function () {
      file64bit_footer.push(reader.result);
    };
    reader.onerror = function (error) {};
    this.finalfileToUpload_footer = file64bit_footer;
  }

  // getVal() {
  //   if (this.filterdata) {
  //     // Font Settings
  //     this.InvoiceTemplatePopup.controls['TEMPLATEFONT'].setValue(this.filterdata.TEMPLATEFONT);
  //     this.InvoiceTemplatePopup.controls['TEMPLATEFONTSIZE'].setValue(this.filterdata.TEMPLATEFONTSIZE);
  //     this.InvoiceTemplatePopup.controls['TEMPLATEFONTCOLOUR'].setValue(this.filterdata.TEMPLATEFONTCOLOUR);
  //     // Header Settings
  //     this.InvoiceTemplatePopup.controls['HEADERSTYLE'].setValue(this.filterdata.HEADERSTYLE);
  //     this.InvoiceTemplatePopup.controls['HEADERIMAGEFILE'].setValue(this.filterdata.HEADERIMAGEFILE);
  //     this.InvoiceTemplatePopup.controls['HEADERIMAGEXPOS'].setValue(this.filterdata.HEADERIMAGEXPOS);
  //     this.InvoiceTemplatePopup.controls['HEADERIMAGEYPOS'].setValue(this.filterdata.HEADERIMAGEYPOS);
  //     this.InvoiceTemplatePopup.controls['HEADERIMAGEWIDTH'].setValue(this.filterdata.HEADERIMAGEWIDTH);
  //     this.InvoiceTemplatePopup.controls['HEADERIMAGEHEIGHT'].setValue(this.filterdata.HEADERIMAGEHEIGHT);
  //     this.InvoiceTemplatePopup.controls['HEADERHEIGHT'].setValue(this.filterdata.HEADERHEIGHT);
  //     // Footer Settings
  //     this.InvoiceTemplatePopup.controls['FOOTERSTYLE'].setValue(this.filterdata.FOOTERSTYLE);
  //     this.InvoiceTemplatePopup.controls['FOOTERIMAGEFILE'].setValue(this.filterdata.FOOTERIMAGEFILE);
  //     this.InvoiceTemplatePopup.controls['FOOTERIMAGEXPOS'].setValue(this.filterdata.FOOTERIMAGEXPOS);
  //     this.InvoiceTemplatePopup.controls['FOOTERIMAGEYPOS'].setValue(this.filterdata.FOOTERIMAGEYPOS);
  //     this.InvoiceTemplatePopup.controls['FOOTERIMAGEWIDTH'].setValue(this.filterdata.FOOTERIMAGEWIDTH);
  //     this.InvoiceTemplatePopup.controls['FOOTERIMAGEHEIGHT'].setValue(this.filterdata.FOOTERIMAGEHEIGHT);
  //     this.InvoiceTemplatePopup.controls['FOOTERHEIGHT'].setValue(this.filterdata.FOOTERHEIGHT);
  //     // General Layout
  //     this.InvoiceTemplatePopup.controls['TAXINVOICETITLE'].setValue(this.filterdata.TAXINVOICETITLE);
  //     this.InvoiceTemplatePopup.controls['ABNLOCATION'].setValue(this.filterdata.ABNLOCATION);
  //     this.InvoiceTemplatePopup.controls['PADZEROSINVOICENUMBER'].setValue(this.filterdata.PADZEROSINVOICENUMBER);
  //     this.InvoiceTemplatePopup.controls['RELINEJUSTIFICATION'].setValue(this.filterdata.RELINEJUSTIFICATION);
  //     this.InvoiceTemplatePopup.controls['SHOWMATTERREFERENCE'].setValue(this.filterdata.SHOWMATTERREFERENCE);
  //     this.InvoiceTemplatePopup.controls['SHOWCOURTDETAILS'].setValue(this.filterdata.SHOWCOURTDETAILS);
  //     this.InvoiceTemplatePopup.controls['PERSONRESPONSIBLE'].setValue(this.filterdata.PERSONRESPONSIBLE);
  //     // Summary Information
  //     this.InvoiceTemplatePopup.controls['SHOWFIRSTPAGESUMMARY'].setValue(this.filterdata.SHOWFIRSTPAGESUMMARY);
  //     this.InvoiceTemplatePopup.controls['FEESDESCRIPTION'].setValue(this.filterdata.FEESDESCRIPTION);
  //     this.InvoiceTemplatePopup.controls['DISBURSEMENTDESCRIPTION'].setValue(this.filterdata.DISBURSEMENTDESCRIPTION);
  //     this.InvoiceTemplatePopup.controls['SHOWSOLICITORSUMMARY'].setValue(this.filterdata.SHOWSOLICITORSUMMARY);
  //     this.InvoiceTemplatePopup.controls['SOLSUMMARYSTYLE'].setValue(this.filterdata.SOLSUMMARYSTYLE);
  //     this.InvoiceTemplatePopup.controls['SHOWDELIVERABLESUMMARY'].setValue(this.filterdata.SHOWDELIVERABLESUMMARY);
  //     // Financial Details
  //     this.InvoiceTemplatePopup.controls['SHOWWRITTENOFFAMOUNT'].setValue(this.filterdata.SHOWWRITTENOFFAMOUNT);
  //     this.InvoiceTemplatePopup.controls['SHOWRECEIVEDAMOUNT'].setValue(this.filterdata.SHOWRECEIVEDAMOUNT);
  //     this.InvoiceTemplatePopup.controls['SHOWBILLINGRECIPIENT'].setValue(this.filterdata.SHOWBILLINGRECIPIENT);
  //     this.InvoiceTemplatePopup.controls['SHOWBILLINGRECIPIENT'].setValue(this.filterdata.SHOWBILLINGRECIPIENT);
  //     this.InvoiceTemplatePopup.controls['SHOWTRUSTBALANCES'].setValue(this.filterdata.SHOWTRUSTBALANCES);
  //     this.InvoiceTemplatePopup.controls['SHOWFOREIGNCURRENCY'].setValue(this.filterdata.SHOWFOREIGNCURRENCY);
  //     this.InvoiceTemplatePopup.controls['GROUPSECRETARIALWORK'].setValue(this.filterdata.GROUPSECRETARIALWORK);
  //     this.InvoiceTemplatePopup.controls['OUTSTANDINGTABLE'].setValue(this.filterdata.OUTSTANDINGTABLE);

  //     this.InvoiceTemplatePopup.controls['HEADERSTYLE'].setValue(this.filterdata.HEADERSTYLE);
  //     this.InvoiceTemplatePopup.controls['HEADERSTYLE'].setValue(this.filterdata.HEADERSTYLE);
  //   }
  // }

  /**
   * Keep the scaled image inside the dashed preview box.
   * Scale grows from the top left, so width and height are the layout size times zoom.
   */
  private clampInsidePreview(
    image: HTMLElement,
    x: number,
    y: number,
    zoom: number,
  ): { x: number; y: number } {
    const bounds = image.parentElement;
    if (!bounds) {
      return { x, y };
    }
    const maxX = Math.max(0, bounds.clientWidth - image.offsetWidth * zoom);
    const maxY = Math.max(0, bounds.clientHeight - image.offsetHeight * zoom);
    return {
      x: Math.min(Math.max(0, x), maxX),
      y: Math.min(Math.max(0, y), maxY),
    };
  }

  /** Largest zoom that still fits the unscaled image inside the preview. */
  private maxZoomInsidePreview(image: HTMLElement): number {
    const bounds = image.parentElement;
    if (!bounds || image.offsetWidth <= 0 || image.offsetHeight <= 0) {
      return Number.POSITIVE_INFINITY;
    }
    const maxZoom = Math.min(
      bounds.clientWidth / image.offsetWidth,
      bounds.clientHeight / image.offsetHeight,
    );
    return maxZoom > 0 ? maxZoom : Number.POSITIVE_INFINITY;
  }

  /**
   * After a zoom change, keep the image's top-left corner inside the preview
   * so the scaled image does not leave the dashed box.
   */
  private holdImageInsidePreview(
    image: HTMLElement,
    zoom: number,
    which: 'header' | 'footer',
  ): void {
    const fallbackX = which === 'header' ? this.defaultXpos : this.defaultXposfooter;
    const fallbackY = which === 'header' ? this.defaultYpos : this.defaultYposfooter;
    const left = parseFloat(image.style.left);
    const top = parseFloat(image.style.top);
    const next = this.clampInsidePreview(
      image,
      Number.isFinite(left) ? left : fallbackX || 0,
      Number.isFinite(top) ? top : fallbackY || 0,
      zoom,
    );
    if (which === 'header') {
      this.defaultXpos = next.x;
      this.defaultYpos = next.y;
    } else {
      this.defaultXposfooter = next.x;
      this.defaultYposfooter = next.y;
    }
    this.renderer.setStyle(image, 'left', next.x + 'px');
    this.renderer.setStyle(image, 'top', next.y + 'px');
  }

  /**
   * Using this function to allow the user to start the header-image draging process.
   * @param event - To get the header-image starting X and Y position.
   */
  startDrag(event: MouseEvent): void {
    this.isDragging = true;
    const containerElement: HTMLElement = this.elementRef.nativeElement.querySelector('.mb-1000');
    const containerX = containerElement.style.left;
    const containerY = containerElement.style.top;
    let newcontainerX = containerX.split('px');
    let newcontainerY = containerY.split('px');
    let newcontainerXValue = newcontainerX[0] && newcontainerX[0] != '' ? newcontainerX[0] : '0';
    let newcontainerYValue = newcontainerY[0] && newcontainerY[0] != '' ? newcontainerY[0] : '0';
    this.initialX = event.clientX - JSON.parse(newcontainerXValue);
    this.initialY = event.clientY - JSON.parse(newcontainerYValue);
    this.renderer.setStyle(this.imageContainer.nativeElement, 'position', 'relative');
  }

  /**
   * USE OF THIS FUNCTION-->Using this function to allow the user to move the image one position to another position.
   *@param event-->getting the image updated X and Y position.
   */

  dragImage(event: MouseEvent): void {
    if (this.isDragging && this.imageContainer) {
      const container = this.imageContainer.nativeElement as HTMLElement;
      const next = this.clampInsidePreview(
        container,
        event.clientX - this.initialX,
        event.clientY - this.initialY,
        this.zoomFactor,
      );
      this.offsetX = next.x;
      this.offsetY = next.y;
      this.defaultXpos = next.x;
      this.defaultYpos = next.y;
      this.renderer.setStyle(container, 'left', next.x + 'px');
      this.renderer.setStyle(container, 'top', next.y + 'px');
    }
  }

  /**
   * USE OF THIS FUNCTION-->Using this function to allow the user to stop the header-image draging process.
   */

  stopDrag(): void {
    if (this.isDragging) {
      this.isDragging = false;
      this.getImagePosition();
    }
  }

  /**
   * USE OF THIS FUNCTION--> using this function we calculate the header-image X,Y position and Also calculate the header-image height and width.
   */

  getImagePosition(): void {
    const containerElement: HTMLElement = this.elementRef.nativeElement.querySelector('.mb-1000');
    if (!containerElement) {
      return;
    }
    const containerX = containerElement.style.left;
    const containerY = containerElement.style.top;
    let updatedXPosition = this.imageservice.getImageMeasurement(containerX);
    let UPDATEDHEADERHEIGHT = this.imageservice.getUpdatedImageYPos(containerY);
    this.InvoiceTemplatePopup.controls['HEADERIMAGEXPOS'].setValue(Math.round(updatedXPosition));
    this.InvoiceTemplatePopup.controls['HEADERIMAGEYPOS'].setValue(Math.round(UPDATEDHEADERHEIGHT));
    const rect = containerElement.getBoundingClientRect();
    this.width = rect.width;
    this.left = rect.left;
    this.right = rect.top;
    this.height = rect.height;
    this.InvoiceTemplatePopup.controls['HEADERIMAGEWIDTH'].setValue(
      Math.round(this.width * this.zoomFactor * 10.4),
    );
    this.InvoiceTemplatePopup.controls['HEADERIMAGEHEIGHT'].setValue(
      Math.round(this.height * this.zoomFactor * 10.42),
    );
  }

  /**
     USE OF THIS FUNCTION-->This function is allow increase the zoom size of the header-image to user.
    */

  zoomIn(): void {
    const image = this.imageContainer?.nativeElement as HTMLElement;
    const nextZoom = this.zoomFactor + 0.1;
    this.zoomFactor = image ? Math.min(nextZoom, this.maxZoomInsidePreview(image)) : nextZoom;
    if (image && this.zoomFactor > 0) {
      this.holdImageInsidePreview(image, this.zoomFactor, 'header');
    }
    this.UpdatedWidthValue = this.width * this.zoomFactor;
    this.getImagePosition();
  }

  /**
     USE OF THIS FUNCTION-->This function is allow decrease the zoom size of the image to user.
    */

  zoomOut(): void {
    const image = this.imageContainer?.nativeElement as HTMLElement;
    this.zoomFactor = Math.max(0.1, this.zoomFactor - 0.1);
    if (image) {
      this.holdImageInsidePreview(image, this.zoomFactor, 'header');
    }
    this.UpdatedWidthValue = this.width * this.zoomFactor;
    this.getImagePosition();
  }

  /**
   * USE OF THIS FUNCTION--> This function is allow increase or decrease the X-position of the header-image using input to user.
   * @remarks
   * 1 inch == 96px
   * As per client backend calculation(1 inch==1000);
   * So As per backend calculation value of the per PX is (1000/96)==10.41666666666667;
   * 1px==10.416666666667
   * @param Xposition-it gives the X-position input field value.
   */

  getNewUpdatedImageXposition(Xposition: number): void {
    const containerElement: HTMLElement = this.elementRef.nativeElement.querySelector('.mb-1000');
    const updatedXPosition = Number(Xposition) / 10.41666666666667;
    this.defaultXpos = updatedXPosition;
    containerElement.style.left = updatedXPosition + 'px';
  }

  /**
   *USE OF THIS FUNCTION--> This function is allow increase or decrease the Y-position of the header-image using input to user.
   *  @remarks
   * 1 inch == 96px
   * As per client backend calculation(1 inch==1000);
   * So As per backend calculation value of the per PX is (1000/96)==10.41666666666667;
   * 1px==10.416666666667
   * @param Yposition-it gives the Y-position input field value.
   */

  getNewUpdatedImageYposition(Yposition: number): void {
    const containerElement: HTMLElement = this.elementRef.nativeElement.querySelector('.mb-1000');
    const updatedYposition = Number(Yposition) / 10.41666666666667;
    this.defaultYpos = updatedYposition;
    containerElement.style.top = updatedYposition + 'px';
  }

  /**
     * USE OF THIS FUNCTION-->This function is allow increase or decrease the Width of the header-image using input to user.

     *@param inputWidth-it gives the Width input field value.
     */

  getNewUpdatedWidth(inputWidth: HTMLInputElement): void {
    const containerElement: HTMLElement = this.elementRef.nativeElement.querySelector('.mb-1000');
    const rect = containerElement.getBoundingClientRect();
    let defaultWidth = rect.width * 10.4;
    let updatedDefaultWidth = (defaultWidth + 1) / defaultWidth - 1;
    const updatedWidth = parseFloat(inputWidth.value);
    this.zoomFactor = updatedWidth * updatedDefaultWidth;
  }

  /**
      * USE OF THIS FUNCTION-->This function is allow increase or decrease the Height of the header-image using input to user.

      *@param inputHeight-it gives the Height input field value.
      */

  getNewUpdatedHeight(inputHeight: HTMLInputElement): void {
    const containerElement: HTMLElement = this.elementRef.nativeElement.querySelector('.mb-1000');
    const rect = containerElement.getBoundingClientRect();
    let mainHeight = rect.height * 10.42;
    let updatedMainHeight = (mainHeight + 1) / mainHeight - 1;
    const inputHeightVal = parseFloat(inputHeight.value);
    this.zoomFactor = inputHeightVal * updatedMainHeight;
  }

  /**
   *  This Code is started for the New Development of the footer Image Setting
   */

  /**
     USE OF THIS FUNCTION-->This function is allow increase the zoom size of the footer-image to user.
    */

  zoomInFooter(): void {
    const image = this.imageFooterContainer?.nativeElement as HTMLElement;
    const nextZoom = this.zoomFooter + 0.1;
    this.zoomFooter = image ? Math.min(nextZoom, this.maxZoomInsidePreview(image)) : nextZoom;
    if (image && this.zoomFooter > 0) {
      this.holdImageInsidePreview(image, this.zoomFooter, 'footer');
    }
    this.UpdatedWidthValue = this.width * this.zoomFooter;
    this.getImagePositionOfFooter();
  }

  /**
     USE OF THIS FUNCTION-->This function is allow increase the zoom size of the footer-image to user.
    */

  zoomOutFooter(): void {
    const image = this.imageFooterContainer?.nativeElement as HTMLElement;
    this.zoomFooter = Math.max(0.1, this.zoomFooter - 0.1);
    if (image) {
      this.holdImageInsidePreview(image, this.zoomFooter, 'footer');
    }
    this.UpdatedWidthValue = this.width * this.zoomFooter;
    this.getImagePositionOfFooter();
  }

  /**
   * USE OF THIS FUNCTION--> using this function we calculate the footer-image X,Y position and Also calculate the footer-image height and width.
   */

  getImagePositionOfFooter() {
    const container = this.imageFooterContainer.nativeElement;
    const rect = container.getBoundingClientRect();
    this.width = rect.width;
    this.InvoiceTemplatePopup.controls['FOOTERIMAGEWIDTH'].setValue(
      Math.round(this.width * this.zoomFooter * 10.4),
    );
    this.InvoiceTemplatePopup.controls['FOOTERIMAGEHEIGHT'].setValue(
      Math.round(rect.height * this.zoomFooter * 10.42),
    );
    const containerElement: HTMLElement =
      this.elementRef.nativeElement.querySelector('.mb-1000-footer');
    const containerX = containerElement.style.left;
    const containerY = containerElement.style.top;
    this.initialYValueOfFooterImage = containerY;
    let updatedXPositionOfFooterImage = this.imageservice.getImageMeasurementOfFooter(containerX);
    let UPDATEDFOOTERRHEIGHT = this.imageservice.getUpdatedImageYPosOfFooter(containerY);
    this.InvoiceTemplatePopup.controls['FOOTERIMAGEXPOS'].setValue(
      Math.round(updatedXPositionOfFooterImage),
    );
    this.InvoiceTemplatePopup.controls['FOOTERIMAGEYPOS'].setValue(
      Math.round(UPDATEDFOOTERRHEIGHT),
    );
  }

  /**
   * USE OF THIS FUNCTION-->Using this function to allow the user to start the footer-image draging process.
   *@param event-->getting the footer-image starting X and Y position.
   */

  startDragfooter(event: MouseEvent): void {
    this.isDraggingfooter = true;
    const containerElement: HTMLElement =
      this.elementRef.nativeElement.querySelector('.mb-1000-footer');
    const containerX = containerElement.style.left;
    const containerY = containerElement.style.top;
    let newcontainerX = containerX.split('px');
    let newcontainerY = containerY.split('px');
    let newcontainerXValue = newcontainerX[0] && newcontainerX[0] != '' ? newcontainerX[0] : '0';
    let newcontainerYValue = newcontainerY[0] && newcontainerY[0] != '' ? newcontainerY[0] : '0';
    this.initialXfooter = event.clientX - JSON.parse(newcontainerXValue);
    this.initialYfooter = event.clientY - JSON.parse(newcontainerYValue);
    this.renderer.setStyle(this.imageFooterContainer.nativeElement, 'position', 'relative');
  }
  /**
   *USE OF THIS FUNCTION---> its helps to drag the image smoothly
   */

  @HostListener('dragstart', ['$event'])
  onDragStart(event: Event): void {
    event.preventDefault();
  }

  /**
   * USE OF THIS FUNCTION-->Using this function to allow the user to move the footer-image one position to another position.
   * @param event-->getting the footer-image updated X and Y position.
   */

  dragImagefooter(event: MouseEvent): void {
    if (this.isDraggingfooter && this.imageFooterContainer) {
      const container = this.imageFooterContainer.nativeElement as HTMLElement;
      const next = this.clampInsidePreview(
        container,
        event.clientX - this.initialXfooter,
        event.clientY - this.initialYfooter,
        this.zoomFooter,
      );
      this.offsetXFooter = next.x;
      this.offsetYFooter = next.y;
      this.defaultXposfooter = next.x;
      this.defaultYposfooter = next.y;
      this.renderer.setStyle(container, 'left', next.x + 'px');
      this.renderer.setStyle(container, 'top', next.y + 'px');
    }
  }

  /**
   * USE OF THIS FUNCTION-->Using this function to allow the user to stop the footer-image draging process.
   */

  stopDragfooter(): void {
    if (this.isDraggingfooter) {
      this.isDraggingfooter = false;
      this.getImagePositionOfFooter();
    }
  }

  /**
   * USE OF THIS FUNCTION--> This function is allow increase or decrease the X-position of the footer-image using input to user.
   *  @remarks
   * 1 inch == 96px
   * As per client backend calculation(1 inch==1000);
   * So As per backend calculation value of the per PX is (1000/96)==10.41666666666667;
   * 1px==10.416666666667
   * @param Xposition-it gives the X-position input field value.
   */

  getNewUpdatedImageXpositionOfFooter(Xposition: number): void {
    const containerElement: HTMLElement =
      this.elementRef.nativeElement.querySelector('.mb-1000-footer');
    const FooterXImageHeight = Number(Xposition) / 10.41666666666667;
    this.defaultXposfooter = FooterXImageHeight;
    containerElement.style.left = FooterXImageHeight + 'px';
  }

  /**
   * USE OF THIS FUNCTION--> This function is allow increase or decrease the Y-position of the footer-image using input to user.
   *  @remarks
   * 1 inch == 96px
   * As per client backend calculation(1 inch==1000);
   * So As per backend calculation value of the per PX is (1000/96)==10.41666666666667;
   * 1px==10.416666666667
   * @param Yposition-it gives the X-position input field value.
   */

  getNewUpdatedImageYpositionOfFooter(Yposition: number): void {
    const containerElement: HTMLElement =
      this.elementRef.nativeElement.querySelector('.mb-1000-footer');
    const FooterYImageHeightdata = (Number(Yposition) - 8000) / 10.41666666666667;
    this.defaultYposfooter = FooterYImageHeightdata;
    containerElement.style.top = FooterYImageHeightdata + 'px';
  }

  /**
      * USE OF THIS FUNCTION-->This function is allow increase or decrease the width of the header-image using input to user.

      * @param inputHeight-it gives the Height input field value.
      */

  getNewUpdatedWidthOfFooter(inputwidth: HTMLInputElement): void {
    const containerElement: HTMLElement =
      this.elementRef.nativeElement.querySelector('.mb-1000-footer');
    const rect = containerElement.getBoundingClientRect();
    let NewUpdatedWidth = rect.width * 10.4;
    let MainNewUpdatedWidth = (NewUpdatedWidth + 1) / NewUpdatedWidth - 1;
    const newMainNewUpdatedWidth = parseFloat(inputwidth.value);
    this.zoomFooter = newMainNewUpdatedWidth * MainNewUpdatedWidth;
  }

  /**
     * USE OF THIS FUNCTION-->This function is allow increase or decrease the Height of the footer-image using input to user.

     * @param inputHeight-it gives the Height input field value.
     */
  getNewUpdatedHeightOfFooter(inputHeight: HTMLInputElement): void {
    const containerElement: HTMLElement =
      this.elementRef.nativeElement.querySelector('.mb-1000-footer');
    const rect = containerElement.getBoundingClientRect();
    let NewUpdatedHeight = rect.height * 10.42;
    let MainNewUpdatedHeight = (NewUpdatedHeight + 1) / NewUpdatedHeight - 1;
    const newMainNewUpdatedHeight = parseFloat(inputHeight.value);
    this.zoomFooter = newMainNewUpdatedHeight * MainNewUpdatedHeight;
  }

  onDirectDebitChange(data) {
    if (data.value == 'Manual Entry') {
      this.isShowAccountInfo = true;
    } else {
      this.isShowAccountInfo = false;
    }
  }
}
